import { UiSchema } from '@rjsf/core';
import { JSONSchema7 } from 'json-schema';
import { useState } from 'react';
import { useIntl } from 'react-intl';
import { IntakeForm } from 'views/pages/client-record/useIntakeForm';
import JsonFormContainer from '../JsonFormContainer';
import Actions from './Actions';

const uiSchema: UiSchema = {
  otherInfo_1: { 'ui:widget': 'textarea', 'ui:options': { row: 15 } },
  otherInfo_2: { 'ui:widget': 'textarea', 'ui:options': { row: 15 } },
  otherInfo_3: { 'ui:widget': 'textarea', 'ui:options': { row: 15 } },
  otherInfo_4: { 'ui:widget': 'textarea', 'ui:options': { row: 15 } },
  otherInfo_5: { 'ui:widget': 'textarea', 'ui:options': { row: 15 } }
};

interface Props {
  intakeForm: IntakeForm;
  onPrevious?: () => void;
  isSubmitting: boolean;
  onSubmit: (data: any) => void;
}

export default function WhereYouAre({ intakeForm, onPrevious, isSubmitting, onSubmit }: Props) {
  const intl = useIntl();
  const schema: JSONSchema7 = {
    type: 'object',
    title: intl.formatMessage({ defaultMessage: "Why You're Here" }),
    properties: {
      otherInfo_1: {
        type: 'string',
        title: intl.formatMessage({ defaultMessage: 'Please list one or more presenting problems:' })
      },
      otherInfo_2: {
        type: 'string',
        title: intl.formatMessage({ defaultMessage: 'What are your goals for counselling?' })
      },
      otherInfo_3: {
        type: 'string',
        title: intl.formatMessage({ defaultMessage: 'What do you consider to be your strengths?' })
      },
      otherInfo_4: {
        type: 'string',
        title: intl.formatMessage({ defaultMessage: 'What do you like most about yourself?' })
      },
      otherInfo_5: {
        type: 'string',
        title: intl.formatMessage({ defaultMessage: 'What are effective coping strategies that you have learned?' })
      }
    }
  };
  const [formData, setFormData] = useState(intakeForm.otherInfo);

  return (
    <JsonFormContainer
      noValidate
      schema={schema}
      uiSchema={uiSchema}
      formData={formData}
      onChange={({ formData }) => setFormData(formData)}
      onSubmit={({ formData }) =>
        onSubmit({
          otherInfo: formData
        })
      }
    >
      <Actions onPrevious={onPrevious} disabled={isSubmitting} />
    </JsonFormContainer>
  );
}
